"use client";

import { c as _c } from "react/compiler-runtime";
import { useEffect } from "react";
declare global {
  interface Window {
    lintrk?: (action: "track", data: {
      conversion_id: number;
    }) => void;
  }
}
const SCROLL_50_CONVERSION_ID = 27_488_057;
const DWELL_30S_CONVERSION_ID = 27_488_065;
const DWELL_MS = 30_000;
const SCROLL_THRESHOLD = 0.5;
// The Insight Tag base code (window.lintrk) is injected async by GTM, so it may
// not exist yet when a trigger fires (e.g. a fast scroll on a fresh load).
// Wait briefly for it instead of dropping the conversion.
const LINTRK_WAIT_MS = 15_000;
const LINTRK_POLL_MS = 300;

/**
 * Fires LinkedIn Insight Tag conversions for engagement signals:
 * - 50% scroll depth
 * - 30 seconds dwell time
 * Each conversion fires at most once per page view. Requires the LinkedIn
 * Insight Tag base code (window.lintrk) to be loaded (via GTM).
 */
export function LinkedInConversions() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = [];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  useEffect(_temp, t0);
  return null;
}
function _temp() {
  const timers = [];
  const fireConversion = conversionId => {
    const start = Date.now();
    const attempt = () => {
      if (typeof window.lintrk === "function") {
        window.lintrk("track", {
          conversion_id: conversionId
        });
        return;
      }
      if (Date.now() - start < LINTRK_WAIT_MS) {
        timers.push(window.setTimeout(attempt, LINTRK_POLL_MS));
      }
    };
    attempt();
  };
  let scrollFired = false;
  const onScroll = () => {
    if (scrollFired) {
      return;
    }
    const scrollable = document.documentElement.scrollHeight - window.innerHeight;
    if (scrollable <= 0) {
      return;
    }
    if (window.scrollY / scrollable >= SCROLL_THRESHOLD) {
      scrollFired = true;
      window.removeEventListener("scroll", onScroll);
      fireConversion(SCROLL_50_CONVERSION_ID);
    }
  };
  timers.push(window.setTimeout(() => {
    fireConversion(DWELL_30S_CONVERSION_ID);
  }, DWELL_MS));
  window.addEventListener("scroll", onScroll, {
    passive: true
  });
  onScroll();
  return () => {
    window.removeEventListener("scroll", onScroll);
    for (const timer of timers) {
      window.clearTimeout(timer);
    }
  };
}